module.exports = __webpack_public_path__ + "static/img/footer_banner_btn2_h5.1ced70a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/footer_banner_btn2_h5.png
// module id = sIaC
// module chunks = 34